import React, { useEffect, useState } from "react";
import logo from "../images/absorved_l.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import api from "../../api/axios";
import { toast } from "react-toastify";
import { useAuth } from "../context/AuthContext";

function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("user");
  const [userdata, setUserdata] = useState([]);
  const [webLoginData, setWebLoginData] = useState([])
  const navigate = useNavigate();
  const compareemail = webLoginData.map((user) => user.email);
  const comparepass = webLoginData.map((user) => user.password);



  const fetchweblogindata = async () => {
    const res = await api.get("/getwebsitelogindata");
    setWebLoginData(res.data)
  }
  useEffect(() => {
    fetchweblogindata()
  }, [])

  useEffect(() => {
    if (email === "adminabsorbx@gmail.com") {
      setRole("admin");
    } else {
      setRole("user");
    }
  }, [email]);

  const fetchuserdata = async () => {
    const res = await api.get("/getuserdata");

    setUserdata(res.data);
  };
  useEffect(() => {
    fetchuserdata();
  }, []);

  const HandleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (
        compareemail.includes(email) && comparepass.includes(password) ||
        ("adminabsorbx@gmail.com" && password === "Temp2025#")
      ) {
        const res = await api.post("/login", { email, password });
        const { data } = res;

        // Save to context
        login(data.email, role);

        // Save to localStorage
        localStorage.setItem(
          "user",
          JSON.stringify({ email: data.email, role })
        );
        localStorage.setItem("useremail", email);
        toast.success("Logged in successfully", { autoClose: 2000 });

        // Navigate
        if (role === "admin") {
          navigate("/customers");
        } else if (role === "user") {
          navigate("/myorder");
        }
      } else {
        toast.error("Invalid email or password");
      }
    } catch (error) {
      toast.error("Invalid email or password");
      console.error("Login error:", error);
    }
  };

  return (
    <div className=" font-[Poppins] bg-[#FAFBFF] h-screen ">
      <div className=" sm:flex h-screen justify-evenly items-center ">
        <div className="max-sm:w-[100px] text-center w-[18%] max-sm:relative max-sm:left-[32%] max-sm:m-2">
          <img src={logo} alt="Logo" />
        </div>
        <div className="border border-[#C65B1D] bg-white m-2 max-sm:mt-10 rounded-xl p-5 shadow-2xl ">
          <h1 className="text-[#C65B1D] font-medium 2xl:text-3xl text-2xl  text-center mb-2 sm:px-10 pt-5">
            Login to your account
          </h1>
          <p className="2xl:mb-10 mb-7 text-center">
            Welcome back! Please enter your details.
          </p>
          <form onSubmit={HandleSubmit} className="space-y-4 sm:mb-6 mb-">
            <div className="flex flex-col mb-5">
              <label htmlFor="email" className="pb-1">
                Email
              </label>
              <input
                type="email"
                id="email"
                onChange={(e) => setEmail(e.target.value)}
                required={true}
                placeholder="Enter Your email"
                className="border border-gray-300 2xl:p-2 p-[0.30rem] rounded"
              />
            </div>
            <div className="flex flex-col mb-10">
              <label htmlFor="password" className="mb-1 ">
                Password
              </label>
              <input
                type="password"
                id="password"
                onChange={(e) => setPassword(e.target.value)}
                required={true}
                placeholder="Password"
                className="border border-gray-300 2xl:p-2 p-[0.30rem]  rounded"
              />
            </div>
            <button
              type="submit"
              className="bg-[#C65B1D] w-full text-white 2xl:p-2 p-[0.40rem] rounded-lg "
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
